import { AutoMap } from "@automapper/classes";

export class MeasureMassifDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    samplingTime!: string;
    @AutoMap()
    localisation!: string;
    @AutoMap()
    samplingID!: number;
    @AutoMap()
    scolaMaterial!: string;
    @AutoMap()
    prelevementEffectue!: boolean;
    @AutoMap()
    isCancelled!: boolean;
    @AutoMap()
    observation!: string;
    @AutoMap()
    processMesureTerrainCode?: string;
    @AutoMap()
    referenceEtiquette?: string
    @AutoMap()
    position!: number;
}